import React, { useState } from 'react';

import Title from '@/components/commons/page-elements/Title';

import MyNetworkSearchBar from './MyNetworkSearchBar';
import ContactsTable from './ContactsTable';

function MyNetworkDashboard() {
    const [filter, setFilter] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    return (
        <div className="">
            <div className="pr-6 mb-10">
                <Title
                    title="My Network"
                    subtitle="View, manage and grow your personal network of contacts."
                    bold
                />
            </div>
            <MyNetworkSearchBar
                filter={filter}
                setFilter={setFilter}
                setSearchTerm={setSearchTerm}
                searchTerm={searchTerm}
            />
            <ContactsTable keyword={searchTerm} filter={filter} />
        </div>
    );
}

export default MyNetworkDashboard;
